module.exports = __webpack_public_path__ + "media/04.99faa124.wav";